import {
    EnviarMensagemAtivaEmMassaService,
    EnviarPesquisaSatisfacaoWppService,
    FiltrarEmpreendimentoFilaService,
    GerarModeloTemplateService,
    ListarContaChatService,
} from "../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";

import { IFiltroGestaoContaChatFechado } from "../../../Interfaces/HelpDesk/GestaoAtendimentos/GestaoAtendimentosInterface";
import { Controller } from "../../Controller";
import { IMensagemAtivaEmMassa } from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { IClienteEmLoteFilter } from "../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";

export async function ListarContaChatController(
    requestBody: IFiltroGestaoContaChatFechado
) {
    return Controller(ListarContaChatService(requestBody));
}
export async function EnviarMensagemAtivaEmMassaController(
    idDocumentoTemplate: number,
    requestBody: Array<IMensagemAtivaEmMassa>
) {
    return Controller(
        EnviarMensagemAtivaEmMassaService(idDocumentoTemplate, requestBody)
    );
}

export async function FiltrarEmpreendimentoFilaController(
    LST_ID_EMPREENDIMENTO: number[],
    FL_FILA_ATENDIMENTO: boolean
) {
    return Controller(
        FiltrarEmpreendimentoFilaService(
            LST_ID_EMPREENDIMENTO,
            FL_FILA_ATENDIMENTO
        )
    );
}

export async function GerarModeloTemplateController(
    requestBody: IClienteEmLoteFilter
) {
    return Controller(GerarModeloTemplateService(requestBody));
}

export async function EnviarPesquisaSatisfacaoWppController(idCaso: number) {
    return Controller(EnviarPesquisaSatisfacaoWppService(idCaso));
}
